export default __webpack_public_path__ + "static/media/multipliers-shadow.4adb52a1.png";